import { Box, useTheme } from "@mui/material"
import { CSSProperties, PropsWithChildren } from "react"

interface ActionBarTextProps {
    sx?: CSSProperties,
}

export const ActionBarText = ({
    children, sx
}: PropsWithChildren<ActionBarTextProps>) => {

    const theme = useTheme();
    const colour = sx?.color;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                color: colour ?? theme.palette.common.black,
                backgroundColor: theme.palette.common.white,
                alignItems: 'center',
                borderRadius: '4px',
                padding: '0 8px',
                height: '38px',
                border: `1px solid ${theme.palette.grey[100]}`,
                ...sx
            }}>
            {children}
        </Box>
    )
}
